import {Avatar, Button, Layout, Popup, Spacer, Text} from '@di-nxt/components';
import React, {useCallback} from 'react';
import {useParams} from 'react-router-dom';
import {useGotoMember} from '../../../..';
import {t} from '../../../../../localization';
import {TeamMember} from '../../../../../services';

export type CourierInfoPopupProps = {
  member: TeamMember | undefined;
};
export const CourierInfoPopup: React.FC<CourierInfoPopupProps> = ({member}) => {
  const handleCallNumber = useCallback(
    () => window.open(`tel:${member?.mobileNo}`, '_blank'),
    [member?.mobileNo],
  );

  const {id} = useParams<{id: string}>();
  const gotoMember = useGotoMember(parseInt(id));

  return (
    <Popup
      trigger={
        <Text variant="inline_14_emphasis" nowrap>
          {member?.display ?? t('screens.schedule.couriercell.unknown.courier')}
        </Text>
      }>
      {() => (
        <Layout
          padding={'20'}
          vertical
          width={200}
          height={264}
          backgroundColor="background_mono_primary"
          raised
          borderRadius="8">
          <Spacer height={'12'} />
          <Layout align="center" vertical>
            <Avatar
              uri={member?.avatarUrl}
              name={member?.firstName}
              size={'96'}
            />

            <Spacer height={'20'} />
            <Text variant={'inline_16_emphasis'}>
              {member?.display
                ? member.display
                : t('screens.schedule.couriercell.unknown.courier')}
            </Text>
            <Spacer height={'8'} />
            <Text variant={'inline_14_default'}>
              {member?.userId
                ? member.userId
                : t('screens.schedule.couriercell.unknown.user')}
            </Text>
            <Spacer height="20" />
            <Text onPress={handleCallNumber} variant={'inline_14_default'}>
              {member?.mobileNo
                ? member.mobileNo
                : t('screens.schedule.couriercell.unknown.mobileno')}
            </Text>
            <Spacer height={'20'} />
          </Layout>
          <Layout>
            <Button
              kind="Secondary"
              title={t('screens.schedule.couriercell.memberbtn')}
              inline={false}
              onPress={() => {
                member && gotoMember(member);
              }}
            />
          </Layout>
        </Layout>
      )}
    </Popup>
  );
};
